import {Formik} from "formik";
import {useMemo, useState} from "react";
import FormDeXuat from "./components/FormDeXuat";
import * as Yup from "yup";
import {DeXuatProvider} from "../../contexts/deXuat";

interface Props {
  warehouseId?: number;
  className?: any;
}

export const DeXuat = (props: Props) => {
  const {warehouseId, className} = props;
  const [dsYeuCau, setDsYeuCau] = useState([]);
  const [detailPhieuYeuCau, setDetailPhieuYeuCau] = useState({});

  let validationSchema = Yup.object({});
  const handleFormSubmit = (values: any) => {
  }

  const contextValue = useMemo(() => ({
    dsYeuCau: dsYeuCau,
    setDsYeuCau: setDsYeuCau,
    detailPhieuYeuCau,
    setDetailPhieuYeuCau,
  }), [dsYeuCau, detailPhieuYeuCau]);
  return (
    <Formik<any>
      initialValues={{}}
      validationSchema={validationSchema}
      onSubmit={handleFormSubmit}
    >
      <DeXuatProvider value={contextValue}>
        <div className="bg-white">
          <div className="flex-1 flex flex-column">
            <div className="py-1">
              <FormDeXuat
                className={className}
                warehouseId={warehouseId}
              />
            </div>
          </div>
        </div>

      </DeXuatProvider>
    </Formik>

  )
}

export default DeXuat;
